package com.esoris.kmpmoout.features.expense.expense_form

import com.esoris.kmpmoout.core.extension.toTitleCase
import com.esoris.kmpmoout.domaindata.expense.Expense
import kotlin.time.Clock
import kotlin.uuid.ExperimentalUuidApi
import kotlin.uuid.Uuid

data class ExpenseFormUiState(
    val isLoading: Boolean = false,
    val loadingMessage: String? = null,
    val errorMessage: String? = null,

    // Data
    val expenseForm: ExpenseForm = ExpenseForm()

)

data class ExpenseForm(
    val validateCount: Int = 0,

    val category: String = "",
    val amount: Long = 0L,
    val note: String = "",

    val categoryError: String? = null,
    val amountError: String? = null,
    val noteError: String? = null,
)

@OptIn(ExperimentalUuidApi::class)
fun ExpenseForm.toNewExpense(userId: String) = Expense(
    category = category.trim().toTitleCase(),
    amount = amount,
    note = note,
    id = Uuid.random().toString() ,
    userId = userId,
    createdAt = Clock.System.now().toEpochMilliseconds(),
)